var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tag',_vm._g(_vm._b({staticClass:"ui-tag",class:`ui-tag--${_vm.resolvedTone}`,style:(_vm.identityStyle),attrs:{"type":_vm.type || undefined}},'el-tag',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }